export default __webpack_public_path__ + "images/referrals-onboarding-step-1.efeb38cb846a296a49e6f4a319382ba2.png";